export default "__VITE_ASSET__3c1d37fd__"